// extracted by mini-css-extract-plugin
export default {"duplicate":"EditTranslationView_duplicate__A7HiW","blockedDuplicate":"EditTranslationView_blockedDuplicate__uUM5d","buttons":"EditTranslationView_buttons__CdZHF"};